import { createLucideIcon } from 'lucide-react';
export const UndoRoundIcon = createLucideIcon('', [
  [
    'path',
    {
      d: 'M4 11.5H16C16 11.5 20 11.5 20 15C20 18.5 16 18.5 16 18.5',
      key: '1cg8ri',
    },
  ],
  [
    'path',
    {
      d: 'M9 5.5L3 11.5L9 17.5',
      key: 'xhwyx8',
    },
  ],
]);
